import React from 'react';

export const BookmarkIcon = () => {
    return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="34"
      version="1.1"
      viewBox="0 0 5.821 8.996"
    >
      <g>
        <path
          fill="none"
          stroke="#fff"
          strokeDasharray="none"
          strokeLinecap="round"
          strokeLinejoin="miter"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M.265 8.731L2.91 6.085l2.646 2.646"
        ></path>
        <path
          fill="none"
          fillOpacity="0.03"
          stroke="#fff"
          strokeDasharray="none"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M5.556 8.731V1.323c0-.586-.472-1.058-1.058-1.058H1.323C.737.265.265.737.265 1.323V8.73"
        ></path>
        <path id="bookmark-fill"
          fill="none"
          fillOpacity="1"
          stroke="none"
          strokeLinecap="round"
          d="M4.293 1.77a.397.397 0 00-.54.154l-1.1 1.984-.696-.521a.397.397 0 00-.555.08.397.397 0 00.08.554l1.422 1.067 1.543-2.78a.397.397 0 00-.154-.538z"
          color="#000"
        ></path>
      </g>
    </svg>
  );
};
